import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    filename = '',
    extra = '', // 服务器原样返回的额外数据
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.common.delUpload, {
        filename,
        extra,
    }, options);
    if (error) return { status, error };
    return content || {};
};
